export default {
    delivery: {
        product: {
            tracking: "Volgen",
            quantity: "Hoeveelheid"
        }
    }
}